const Resources = {

    table_headers: [
        {
            text: '#Room',
            value: 'walking_number'
        },
        {
            text: 'Description',
            value: 'custom_description',
        },
        {
            text: 'Task',
            value: 'task',
        },
        {
            text: 'Minutes',
            value: 'minutes',
        },
        {
            text: 'Annual Min',
            value: 'annual_minutes',
        },
        {
            text: 'Frequency',
            value: 'frequency',
        },
        { 
            text:  'Last Completed',
            value: 'last_completed',
        },
        { 
            text:  'Next Scheduled',
            value: 'next_scheduled',
        },
        {
            text: 'Group',
            value: 'work_group'
        },
    ],

    default_filters: [{key: 'radio', value: 'projects'}],

    
    filter_options:
    {
        show_properly_assigned_rooms: false,
        show_rooms_that_are: false,
        daily: false,
        policing: false,
        projects: true,
    },

    scheduled_table_headers: [
        { 
            text:  'Walking#',
            value: 'walking_number',
            type:  'link',
        },
        { 
            text:  'Description',
            value: 'description',
            type:  'link',
        },
        { 
            text:  'Frequency',
            value: 'frequency'
        },
        { 
            text:  'Task',
            value: 'task',
        },
    ],

    week_table_headers: [
        {
            name: 'Sun'
        },
        {
            name: 'Mon'
        },
        {
            name: 'Tue'
        },
        {
            name: 'Wed'
        },
        {
            name: 'Thu'
        },
        {
            name: 'Fri'
        },
        {
            name: 'Sat'
        },
    ],

    breadcrumb:[
        {
            name:   'Home',
            href:   '/',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Assignments',
            href:   '/assignment-daily-assignments',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Projects',
            href:   '/assignment-projects',
            arrow:  "<span class='slash'>/</span>",
        },
    ],

    boolean_options:[
        {
            id:     true,
            name:   'Yes',
        },
        {
            id:     false,
            name:   'No',
        },
    ],

    excl_options:[
        {
            id:     true,
            name:   'Yes',
        },
        {
            id:     false,
            name:   'No',
        },
    ],

    freq_options:[
        {
            id:     1,
            name:   '=',
        },
        {
            id:     2,
            name:   '<',
        },
        {
            id:     3,
            name:   '>',
        },
    ],

}

export default Resources;